import Colors, { blend, withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const ChipTheme = {
    chip: {
        light: {
            iconColor: withOpacity(Colors.black, Opacities.medium),
            states: {
                enabled: {
                    color: withOpacity(Colors.black, Opacities.medium),
                    backgroundColor: Colors.transparent,
                    borderColor: withOpacity(Colors.black, Opacities.medium),
                },
                disabled: {
                    color: withOpacity(Colors.black, Opacities.low),
                    backgroundColor: Colors.transparent,
                    borderColor: withOpacity(Colors.black, Opacities.xLow),
                },
                hover: {
                    color: Colors.black,
                    backgroundColor: Colors.transparent,
                    borderColor: withOpacity(Colors.black, Opacities.medium),
                },
                // Do not use, use selected state
                active: {
                    color: Colors.black,
                    backgroundColor: Colors.accessibleSafetyOrange,
                    borderColor: Colors.accessibleSafetyOrange,
                },
                // TODO: this should be named active in the future, design will define this in the future
                selected: {
                    color: Colors.black,
                    backgroundColor: Colors.accessibleSafetyOrange,
                    borderColor: Colors.accessibleSafetyOrange,
                },
                selectedHover: {
                    color: Colors.black,
                    backgroundColor: blend(Colors.accessibleSafetyOrange, Colors.white, Opacities.xLow),
                    borderColor: blend(Colors.accessibleSafetyOrange, Colors.white, Opacities.low),
                },
            },
        },
        dark: {
            iconColor: withOpacity(Colors.white, Opacities.medium),
            states: {
                enabled: {
                    color: withOpacity(Colors.white, Opacities.medium),
                    backgroundColor: Colors.transparent,
                    borderColor: withOpacity(Colors.white, Opacities.medium),
                },
                disabled: {
                    color: withOpacity(Colors.white, Opacities.low),
                    backgroundColor: Colors.transparent,
                    borderColor: withOpacity(Colors.white, Opacities.xLow),
                },
                hover: {
                    color: Colors.white,
                    backgroundColor: Colors.transparent,
                    borderColor: Colors.white,
                },
                // Do not use, use selected state
                active: {
                    color: Colors.white,
                    borderColor: withOpacity(Colors.white, Opacities.medium),
                },
                // TODO: this should be named active in the future, design will define this in the future
                selected: {
                    color: Colors.black,
                    backgroundColor: Colors.accessibleSafetyOrange,
                    borderColor: Colors.accessibleSafetyOrange,
                },
                selectedHover: {
                    color: Colors.black,
                    backgroundColor: blend(Colors.accessibleSafetyOrange, Colors.black, Opacities.xLow),
                    borderColor: blend(Colors.accessibleSafetyOrange, Colors.black, Opacities.low),
                },
            },
        },
    },
};
export default ChipTheme;
